import React from "react";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

interface ErrorPageProps {
	error: any;
}
export const ErrorPage = ({ error }: ErrorPageProps) => {
	const status: number = error.response
		? error.response.status
		: error.statusCode;

	if (status === 401) {
		window.location.href = "/logout";
		return null;
	}

	if (status) {
		const messages = {
			401: (
				<FormattedMessage
					id="minside.error_page.no_access"
					defaultMessage="Ingen tilgang"
					description="No access error page"
				/>
			),
			default: (
				<FormattedMessage
					id="minside.error_page.default_error"
					defaultMessage="En feil har oppstått"
					description="Default message error page"
				/>
			)
		};
		return (
			<Typography variant="h5">
				{(status === 401 && messages[401]) || messages["default"]}
			</Typography>
		);
	}

	return (
		<Typography variant="h5">
			<FormattedMessage
				id="minside.error_page.default_error_nostatus"
				defaultMessage="En feil har oppstått"
				description="Default message error page"
			/>
		</Typography>
	);
};
